import React, { useContext } from "react";
import DropdownContext from "../context";


export const useHandleOnKeyDown = () => {

const {
  asyncEnabled,
  autocomplete,
  creationEnabled,
  creationOption,
  filterItem,
  filteredOptions,
  focusedOptionIndex,
  handleChange,
  handleOptionClick,
  isDropDownClosed,
  multiSelect,
  selected,
  setFocusedOptionIndex,
  setIsDropDownClosed,
}= useContext(DropdownContext)

  // Helper function to find next non-disabled option
  const findNextAvailableIndex = (currentIndex: number, direction: 'forward' | 'backward'): number => {
    let nextIndex = currentIndex;
    let attempts = 0;

    while (attempts < filteredOptions.length) {
      if (direction === 'forward') {
        nextIndex = (nextIndex + 1) % filteredOptions.length;
      } else {
        nextIndex = (nextIndex - 1 + filteredOptions.length) % filteredOptions.length;
      }

      if (!filteredOptions[nextIndex]?.disabled) {
        return nextIndex;
      }
      attempts++;
    }

    // If all options are disabled, return current index
    return currentIndex;
  };

  return (e: React.KeyboardEvent) => {
    if (e.defaultPrevented) return;
    const isComposing = e.nativeEvent.isComposing || e.keyCode === 229;
    if (creationEnabled && isComposing) return;

    const printableKey = e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
    const replacingSelectedLabel = filterItem === selected?.label;

    // Replace the label only while the input still shows it. After the text diverges,
    // the input inserts the character so the rest of the query stays.
    if (autocomplete && !multiSelect && selected?.label &&
        replacingSelectedLabel &&
        printableKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      handleChange({ target: { value: e.key } }, true);
      return;
    }

    switch (e.key) {
    case "Escape":
      if (asyncEnabled || creationEnabled) {
        setIsDropDownClosed(true);
        setFocusedOptionIndex(-1);
      }
      break;
    case "ArrowDown": {
      e.preventDefault();
      setIsDropDownClosed(false);
      const nextIndex = findNextAvailableIndex(focusedOptionIndex, 'forward');
      setFocusedOptionIndex(nextIndex);
      break;
    }
    case "ArrowUp": {
      e.preventDefault();
      const nextIndexUp = findNextAvailableIndex(focusedOptionIndex, 'backward');
      setFocusedOptionIndex(nextIndexUp);
      break;
    }
    case "Enter": {
      const focusedOption = filteredOptions[focusedOptionIndex];
      const canSelectFocused = focusedOptionIndex !== -1 &&
        (!asyncEnabled || focusedOption) &&
        !focusedOption?.disabled;
      // A closed menu or blank query stays available for form submission unless an option is highlighted.
      if (creationEnabled && (isDropDownClosed || (!filterItem.trim() && !canSelectFocused))) return;
      if (canSelectFocused) {
        e.preventDefault();
        handleOptionClick(focusedOption);
        setFocusedOptionIndex(-1)
      } else if (focusedOptionIndex === -1) {
        if (creationEnabled && creationOption) {
          e.preventDefault();
          handleOptionClick(creationOption);
        } else {
          setIsDropDownClosed(false)
        }
      }
      break;
    }
      case "Tab":
        setIsDropDownClosed(true);
        setFocusedOptionIndex(-1)
        break;
  }
}
};
